module.exports = __webpack_public_path__ + "img/compare.5cb56ba6.svg";